import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import translationFR from './locales/fr/translation.json';
import translationNL from './locales/nl/translation.json';
// the translations
const resources = {
    fr: {
        translation: translationFR
    },
    nl: {
        translation: translationNL
    }
};
const detectionOptions = {
    order: ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag'],
    lookupQuerystring: 'lng',
    lookupCookie: 'i18next',
    lookupLocalStorage: 'i18nextLng',
    lookupSessionStorage: 'i18nextLng',
    // cache user language
    caches: ['localStorage'],
    excludeCacheFor: ['cimode'],
    cookieMinutes: 10
}
i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .use(LanguageDetector) // passes i18n down to react-i18next
    .init({
        detection: detectionOptions,
        // currently we only support Dutch
        supportedLngs: ["nl", "fr"],
        // when no language is detected, fallback to Dutch
        fallbackLng: "nl",
        resources,
        keySeparator: false, // we do not use keys in form messages.welcome
        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });
export default i18n;
